import React from 'react';
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react';

const MONTH_NAMES = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

const DAY_NAMES = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];

const BookingCalendar = ({ 
  currentMonth, 
  setCurrentMonth, 
  selectedDate, 
  onDateSelect 
}) => {
  
  const generateCalendarDays = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + 30);

    const days = [];
    const startPadding = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;
    
    for (let i = 0; i < startPadding; i++) {
      days.push(null);
    }

    for (let day = 1; day <= lastDay.getDate(); day++) {
      const date = new Date(year, month, day);
      const isPast = date < today;
      const isTooFar = date > maxDate;
      days.push({
        day,
        date,
        disabled: isPast || isTooFar,
        isToday: date.toDateString() === today.toDateString(),
        isSelected: selectedDate && date.toDateString() === selectedDate.toDateString()
      });
    }

    return days;
  };

  const canGoNextMonth = () => {
    const today = new Date();
    const maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + 30);
    const nextMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
    return nextMonth <= maxDate;
  };

  const canGoPrevMonth = () => {
    const today = new Date();
    return currentMonth.getMonth() >= today.getMonth() && currentMonth.getFullYear() >= today.getFullYear();
  };

  const handleDateSelect = (dayObj) => {
    if (dayObj && !dayObj.disabled) {
      onDateSelect(dayObj.date);
    }
  };

  return (
    <div>
      <label className="text-[#FFCC00] text-sm font-semibold uppercase tracking-wider mb-3 flex items-center gap-2">
        <Calendar className="w-4 h-4" />
        Seleziona Data
      </label>
      
      {/* Month Navigation */}
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1))}
          disabled={!canGoPrevMonth()}
          className="p-2 text-gray-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed"
          data-testid="calendar-prev-month"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <span className="text-white font-semibold">
          {MONTH_NAMES[currentMonth.getMonth()]} {currentMonth.getFullYear()}
        </span>
        <button
          onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1))}
          disabled={!canGoNextMonth()}
          className="p-2 text-gray-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed"
          data-testid="calendar-next-month"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>

      {/* Day Names */}
      <div className="grid grid-cols-7 gap-1 mb-2">
        {DAY_NAMES.map(day => (
          <div key={day} className="text-center text-gray-500 text-xs py-2">
            {day}
          </div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div className="grid grid-cols-7 gap-1">
        {generateCalendarDays().map((dayObj, index) => (
          <button
            key={dayObj ? `day-${dayObj.date.toISOString()}` : `empty-${index}`}
            onClick={() => handleDateSelect(dayObj)}
            disabled={!dayObj || dayObj.disabled}
            className={`
              aspect-square flex items-center justify-center text-sm transition-all
              ${!dayObj ? 'invisible' : ''}
              ${dayObj?.disabled ? 'text-gray-600 cursor-not-allowed' : 'hover:bg-[#FFCC00]/20'}
              ${dayObj?.isToday ? 'border border-[#FFCC00]/50' : ''}
              ${dayObj?.isSelected ? 'bg-[#FFCC00] text-[#0A0A0A] font-bold' : 'text-white'}
            `}
          >
            {dayObj?.day}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BookingCalendar;
